import "./Contacts.scss";
import { Avatar, Modal, QRCode } from "antd";
import { useSelector } from "react-redux";
import {
  AlbanianFlagIcon,
  Delete,
  EmailIcon,
  KosovoFlagIcon,
  ModalXIcon,
  PhoneIcon,
} from "../../../../assets/icons";
import { getInitials } from "../../../../utils";
import MondayButton from "../../../commonComponents/MondayButton/MondayButton";
import { useAuth } from "../../../../authentication/authHelpers";
import { useEffect, useState } from "react";
import { formatPhoneNumber } from "./utils";

const DetailedContactModal = ({
  open,
  setOpen,
  contact = {},
  setOpenEditMode,
  handleDelete = () => {},
}) => {
  const { user } = useAuth();

  const { isDarkMode } = useSelector((state) => state.usersList);

  const [contactQR, setContactQR] = useState("");

  const isAdmin =
    user?.userRole === "Admin" || user?.userRole === "Super Admin";

  const handleDownload = () => {
    const blob = new Blob([contactQR], { type: "text/vcard;charset=utf-8" });
    const link = document.createElement("a");
    link.download = "contact.vcf";
    link.href = URL.createObjectURL(blob);
    link.click();
  };

  useEffect(() => {
    if (!contact) return;

    const nameParts = contact.fullName.split(" ");
    const firstName = nameParts[0] || "";
    const lastName = nameParts.slice(1).join(" ") || "";

    const vCard = [
      "BEGIN:VCARD",
      "VERSION:3.0",
      `N:${lastName};${firstName};;;`,
      `FN:${contact.fullName}`,
      "ORG:Flex Business Solutions",
      `TEL:+${contact.employeePhoneNumber}`,
      `EMAIL:${contact.employeeEmail}`,
      `TITLE:${contact.employeeRoleName}`,
      `NOTE:${contact.department}`,
      "END:VCARD",
    ].join("\n");

    setContactQR(vCard);
  }, [contact]);

  return (
    <Modal
      open={open}
      onCancel={() => setOpen(false)}
      footer={[
        <div style={{ display: "flex", gap: 10, justifyContent: "center" }}>
          <MondayButton
            onClick={() => setOpen(false)}
            className="mondayButtonGrey"
          >
            Mbyllni Faqen
          </MondayButton>
          {isAdmin ? (
            <MondayButton
              Icon={<Delete />}
              onClick={(e) => {
                handleDelete(e, contact, () => setOpen(false));
              }}
              className="mondayButtonRed"
            />
          ) : null}
        </div>,
        <div style={{ display: "flex", gap: 10, justifyContent: "center" }}>
          {isAdmin ? (
            <MondayButton
              className="mondayButtonBlue"
              onClick={() => {
                setOpen(false);
                setOpenEditMode(contact);
              }}
            >
              Bëni ndryshime
            </MondayButton>
          ) : null}
          <MondayButton onClick={handleDownload} className="mondayButtonBlue">
            Shkarkoni vCard
          </MondayButton>
        </div>,
      ]}
      centered
      closeIcon={<ModalXIcon />}
      title={contact.fullName}
      className={`detailedContactModal ${
        isDarkMode ? "dark darkHeader" : "lightHeader"
      }`}
    >
      <div className="detailedContactContent">
        <Avatar size={56} shape="round" src={contact.src}>
          {getInitials(contact.fullName)}
        </Avatar>
        <div className="contactItem">
          <div className="contactItemDetails">
            <span className="bold">{contact.fullName}</span>
            <span className="divider" />
            <span>{contact.department}</span>
            <span className="divider" />
            <span>{contact.employeeRoleName}</span>
          </div>
          <div className="contactItemDetails subTitle">
            <span>
              {flag(contact.employeeTeam)}
              {contact.employeeTeam}
            </span>
            <span>
              <PhoneIcon />
              {formatPhoneNumber(contact.employeePhoneNumber)}
            </span>
            <span className="divider" />
            <span>
              <EmailIcon />
              {contact.employeeEmail}
            </span>
          </div>
        </div>
        <span style={{ padding: "0px 20px", textAlign: "center" }}>
          {contact.employeeDetails}
        </span>
        <QRCode
          size={256}
          errorLevel="H"
          bgColor="#F1F1F5"
          value={contactQR || "-"}
        />
        <span style={{ color: "#acacac", maxWidth: 280, textAlign: "center" }}>
          Skanoni këtë kod QR me telefonin tuaj për të ruajtur informacionin e
          kontaktit, ose shkarkoni vCard më poshtë.
        </span>
      </div>
    </Modal>
  );
};

export default DetailedContactModal;

export const flag = (team) => {
  if (!team) return null;
  const flags = {
    "Flex Tirana": <AlbanianFlagIcon className="flag" />,
    "Flex Prishtina": <KosovoFlagIcon className="flag" />,
  };
  return flags[team] || null;
};
